import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useRef, useEffect } from 'react';
import { useQuery } from 'react-query';
import { urlcdn, vpmobile } from '../../../utils';
import * as API from '../../API';
import './PageHeader.scss';
const PageHeaderAttic = ({ children, show = true, className }) => {
    const clx = `page-header-attic ${(className !== null && className !== void 0 ? className : '')}`.trim();
    return _jsx("div", { className: clx, children: _jsx("div", { className: "page-dim", children: children }) });
};
const PageHeaderKicker = ({ children, className, href, title }) => {
    const clx = `page-header-kicker ${(className !== null && className !== void 0 ? className : '')}`.trim();
    return (href ? _jsx("h2", { className: clx, children: _jsx("a", { href: href, title: title !== null && title !== void 0 ? title : '', children: children }) })
        : _jsx("h2", { className: clx, children: children }));
};
const PageHeaderTitle = ({ children, className }) => {
    const clx = `page-header-title ${className !== null && className !== void 0 ? className : ''}`.trim();
    return (_jsx("h3", { className: clx, children: children }));
};
const PageHeaderInfographics = ({ children, className }) => {
    const clx = `page-header-infographics ${(className !== null && className !== void 0 ? className : '')}`.trim();
    return (_jsx("div", { className: clx, children: children }));
};
export const PageHeader = ({ children, centeredOverlay, backgroundImage, backgroundVideo, heraldryKnr, className = '', darken = false, blur = false }) => {
    var _a;
    const [mobileViewport, setMobileViewport] = useState(vpmobile());
    useEffect(() => {
        const testViewportSize = () => { setMobileViewport(vpmobile()); };
        window.addEventListener('resize', testViewportSize);
        return () => { window.removeEventListener('resize', testViewportSize); };
    }, []);
    const infoRef = useRef(null);
    const { data: codeListData } = useQuery('kb/kodeliste', API.fetchCodeList);
    if (codeListData) {
        infoRef.current = heraldryKnr
            ? {
                kommune_knr: heraldryKnr,
                kommune_navn: (_a = codeListData.kommuner[heraldryKnr !== null && heraldryKnr !== void 0 ? heraldryKnr : '']) !== null && _a !== void 0 ? _a : null
            }
            : null;
    }
    const heraldry = heraldryKnr && infoRef.current
        ? _jsx("img", { className: "page-header-heraldry", title: `${infoRef.current.kommune_navn}`, src: `${urlcdn()}/kommunevaapen/${infoRef.current.kommune_knr}.png` })
        : null;
    const attic = React.Children.toArray(children).find(child => React.isValidElement(child) &&
        child.type === PageHeaderAttic);
    const withAttic = React.isValidElement(attic);
    const kicker = React.Children.toArray(children).find(child => React.isValidElement(child) &&
        child.type === PageHeaderKicker);
    const title = React.Children.toArray(children).find(child => React.isValidElement(child) &&
        child.type === PageHeaderTitle);
    const infographics = React.Children.toArray(children).find(child => React.isValidElement(child) &&
        child.type === PageHeaderInfographics);
    const jsxLine1 = kicker
        ? _jsxs("div", { className: "page-header-text-ln1", children: [heraldry, kicker] })
        : false;
    const jsxLine2 = title
        ? kicker ? _jsx("div", { className: "page-header-text-ln2", children: title })
            : _jsxs("div", { className: "page-header-text-ln2", children: [heraldry, title] })
        : false;
    const containerClsx = [
        'page-header',
        withAttic ? 'with-attic' : '',
        infographics ? 'with-infographics' : '',
        heraldryKnr ? 'with-heraldry' : '',
        darken ? 'darken' : '',
        blur ? 'blur' : '',
        className
    ].filter(v => v !== '').join(' ');
    const contentClsx = [
        'page-header-content',
        heraldryKnr ? 'with-heraldry' : '',
        darken ? 'darken' : '',
        blur ? 'blur' : ''
    ].filter(v => v !== '').join(' ');
    const videoLoop = backgroundVideo
        ? _jsx("video", { autoPlay: true, loop: true, muted: true, playsInline: true, preload: "auto", children: _jsx("source", { src: backgroundVideo, type: "video/mp4" }) })
        : null;
    const overlayImage = centeredOverlay
        ? _jsx("img", { className: "centered-overlay", src: centeredOverlay })
        : null;
    const textBlock = _jsxs("div", { className: `page-header-text-block ${!kicker ? 'no-kicker' : ''}`, children: [jsxLine1, jsxLine2] });
    return (_jsx(_Fragment, { children: _jsxs("div", { className: containerClsx, style: backgroundImage ? { backgroundImage: `url('${backgroundImage}')` } : {}, children: [overlayImage, _jsxs("div", { className: "filter-overlay", children: [videoLoop, _jsxs("div", { className: "page-header-content", children: [attic, _jsxs("div", { className: `page-dim${mobileViewport ? ' no-gutter' : ''}`, children: [mobileViewport ? null : textBlock, infographics] })] })] }), mobileViewport ? _jsx("div", { className: "page-dim page-header-below", children: textBlock }) : null] }) }));
};
PageHeader.Attic = PageHeaderAttic;
PageHeader.Kicker = PageHeaderKicker;
PageHeader.Title = PageHeaderTitle;
PageHeader.Infographics = PageHeaderInfographics;
